export const ACCESS_GRANTED = "ACCESS_GRANTED";
export const ACCESS_DENIED = "ACCESS_DENIED";
export const ACCESSES_RECEIVED = "ACCESSES_RECEIVED";
export const SET_ACCESS = "SET_ACCESS";
